import axios from './axios'
// import qs from "qs";

function service(endpoint) {
    function processImport(id, data) {
        return axios.post(`${endpoint}/${id}/import`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    return {
        processImport
    }
}

export default service
